module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/iphone-x-back-0311f7df258cec65517c84e031d374ab.svg";